import { useAiRovoCurrentRouteConfigurationStore } from './aiRovoCurrentRouteConfigurationStore.tsx';

export const useAiRovoCurrentRouteConfiguration = () => {
	const configuration = useAiRovoCurrentRouteConfigurationStore((state) => state.configuration);
	return configuration;
};
